/** English */
export default {
  lang_zh_hans: '简体中文',
  lang_zh_hant: '繁體中文',
  lang_en: 'English',
  lang_picker_title: 'Select language',
  lang_switch: 'Language',
  lang_current: 'Current language',

  common_back: 'Back',
  common_cancel: 'Cancel',
  common_ok: 'OK',
  common_confirm: 'Confirm',
  common_close: 'Close',
  common_query: 'Query',
  common_setting: 'Settings',
  common_save: 'Save',
  common_submit: 'Submit',
  common_loading: 'Loading...',
  common_empty: 'No data',
  common_tip: 'Notice',
  common_yuan: '',
  common_scan: 'Scan',
  common_scan_get: 'Scan to fill',
  common_scan_error: 'Scan error',
  common_please_enter: 'Please enter',
  common_exit_system: 'Exit the system?',
  common_retry: 'Retry',
  common_filter: 'Filter',
  common_date: 'Date',
  common_all: 'All',
  net_error_reconnect: 'Processing{0}s',
  brand_hst: 'HuiShangTong',
  brand_epay: 'E-Pay',
  brand_spay: 'SPayPOS',

  home_loading: 'Loading...',
  home_query: 'Query',
  home_zbf: 'Table Pay',
  home_setting: 'Settings',
  home_exit: 'Exit',
  home_set_outlet: 'Please set outlet',
  home_discount_trade: 'Discount trade',
  home_cashier: 'Cashier',
  home_refund: 'Refund',

  setting_title: 'Settings',
  setting_param: 'Parameters',
  setting_maintenance: 'Manual',
  setting_device_info: 'Device info',
  setting_logon: 'Sign in',
  setting_print_bill: 'Print bill',
  setting_upload: 'Upload logs',
  setting_clear_cache: 'Clear cache',
  setting_channel: 'Channel',
  setting_discount: 'Discount',
  setting_exit: 'Exit system',
  setting_address: 'Address',
  setting_ter_bind: 'Terminal bind',
  setting_lang: 'Language',
  setting_settle: 'Settle',
  setting_update: 'Update',

  print_bill_title: 'Print bill',
  print_bill_start: 'Start date',
  print_bill_end: 'End date',
  print_bill_total: 'Print summary',
  print_bill_detail: 'Print detail',
  print_bill_need_date: 'Please select start and end date',
  print_bill_success: 'Print success',
  print_bill_fail: 'Print failed',

  password_title: 'Security check',
  password_need_6: 'Password must be 6 digits',
  password_wrong: 'Wrong password',

  ter_bind_title: 'Parameters',
  ter_bind_trade_url: 'Trade URL',
  trade_url_pick: 'Pick',
  trade_url_pick_title: 'Select trade URL',
  trade_url_env_prod: 'Production',
  trade_url_env_uat: 'UAT',
  trade_url_env_dev: 'Development',
  trade_url_input_hint: 'Pick, scan, or enter manually',

  ter_bind_platform: 'Platform No.',
  ter_bind_outlet: 'Outlet',
  ter_bind_comm_mode: 'Comm mode',
  ter_bind_poll: 'Polling (stable)',
  ter_bind_push: 'Push (fast)',
  ter_bind_day_poll: 'Day poll (sec)',
  ter_bind_night_poll: 'Night poll (sec)',
  ter_bind_push_url: 'Push URL',
  ter_bind_more: 'More',
  ter_bind_zbf: 'Table Pay',
  ter_bind_auto_submit: 'Auto submit',
  ter_bind_throttle: 'Throttle',
  ter_bind_once: 'Single interact',
  ter_bind_self_cashier: 'Self cashier',
  ter_bind_mask: 'Enable mask',
  ter_bind_pre_upload: 'Pre-upload',
  ter_bind_auth_complete_print: 'Print on auth complete',
  ter_bind_add_auth_print: 'Print on add auth',
  ter_bind_wait_time: 'Countdown (sec)',
  ter_bind_reprint_num: 'Print copies',
  ter_bind_remark_space: 'Remark spaces',
  ter_bind_auth_pwd: 'Auth password',
  ter_bind_discount_url: 'Discount URL',
  ter_bind_remark_space_ph: 'Remark blank lines',
  ter_bind_auth_pwd_ph: 'Refund/void password, 6 digits',
  ter_bind_open_hidden: 'Show hidden params',
  ter_bind_close_hidden: 'Hide hidden params',
  ter_bind_save_ok: 'Saved',

  ter_info_title: 'Device info',
  ter_info_version: 'App version: ',
  ter_info_vendor: 'Vendor: ',
  ter_info_sn: 'Serial No.: ',
  ter_info_model: 'Model: ',
  ter_info_os: 'OS version: ',
  ter_info_net: 'Network: ',
  ter_info_wifi: 'WiFi',
  ter_info_mobile: 'Mobile',
  ter_info_desktop: 'Desktop version: ',
  ter_info_lng: 'Longitude: ',
  ter_info_lat: 'Latitude: ',
  ter_info_city_code: 'City code: ',
  ter_info_city_name: 'City: ',
  ter_info_address: 'Address: ',
  tip_amount: 'Tip amount',
  upload_title: 'Upload logs',
  upload_pick_day: 'Select a day',
  upload_btn: 'Upload',
  upload_log: 'Logs',
  upload_data: 'Data',
  upload_need_date: 'Please select a date',
  upload_need_type: 'Select at least one file type',
  upload_fail: 'Upload failed, contact support',

  delcache_title: 'Clear cache',
  delcache_btn: 'Clear cache',
  delcache_clear: 'Clear',
  delcache_confirm: 'Clear records older than 6 months?',

  seturl_title: 'Settings',
  seturl_address: 'Server URL',
  seturl_scanable: 'Scan to fill',
  seturl_success: 'Saved',

  channel_title: 'Channel',
  channel_success: 'Saved',

  discount_bind_title: 'Terminal bind',
  discount_id_code: 'ID code',
  discount_scan_qr: 'Scan QR to fill',
  discount_term_code: 'Terminal code',
  discount_mch_name: 'Merchant name',
  discount_mch_no: 'Merchant No.',
  discount_term_name: 'Terminal name',
  discount_org_id: 'Org ID',
  discount_inst_id: 'Inst ID',
  discount_term_id: 'Terminal ID',
  discount_bound: 'Bound',
  discount_bind: 'Bind',

  maintenance_title: 'Manual',
  push_title: 'Push settings',
  push_bank_void: 'Allow same-day bank void',

  poll_retry: 'Retry',
  poll_check_config: 'Check config',
  poll_net_retry: 'Network error, reconnect in {0}',

  cashier_title: 'Quick cashier',
  cashier_bank: 'Bank card',
  cashier_qr: 'QR code',
  cashier_switch: '(tap to switch)',
  cashier_need_expr: 'Enter expression',
  cashier_need_equal: 'Press equals first',
  cashier_need_amount: 'Enter amount',
  cashier_pay: 'Pay',
  cashier_done: 'Done',
  cashier_union_qr: 'UnionPay QR',
  cashier_wechat: 'WeChat',
  cashier_alipay: 'Alipay',
  cashier_other: 'Other',

  query_title: 'Query',
  query_trade_detail: 'Transactions',
  query_unknown: 'Unknown txn',
  query_icbc: 'ICBC details',
  query_discount: 'Discount details',
  query_act: 'Campaigns',
  query_luckdraw: 'Lucky draw',
  query_bank_flow: 'Bank flow',
  query_bank_unknown: 'Unknown bank txn',
  query_qr_unknown: 'Unknown QR txn',
  query_mch_discount: 'Merchant discount',
  query_notify_exc: 'Notify errors',
  query_notify_exc_mis: 'Upload errors',

  trade_type: 'Type',
  trade_type_colon: 'Type: ',
  trade_ref_no: 'Reference No.',
  trade_ref_no_colon: 'Ref No.:',
  trade_ref_no_origin: 'Original reference No.',
  trade_amount: 'Amount',
  trade_amount_colon: 'Amount: ',
  trade_order_no: 'Merchant order',
  trade_order_no_colon: 'Order No.:',
  trade_order_no_local: 'Local order No.',
  trade_order_no_ph: 'Enter merchant order No.',
  trade_time: 'Time',
  trade_time_colon: 'Time:',
  trade_card: 'Card No.',
  trade_card_colon: 'Card:',
  trade_card_no: 'Card No.',
  trade_card_ph: 'Enter card No.',
  trade_get_card: 'Read card',
  trade_read_card: 'Read card',
  trade_read_card_hint: 'Swipe / insert / type',
  trade_success: 'Success',
  trade_fail: 'Failed',
  trade_unknown: 'Unknown',
  trade_upload_ok: 'Upload OK',
  trade_upload_fail: 'Upload failed',
  trade_bank: 'Bank card',
  trade_qr: 'QR code',
  trade_print: 'Print receipt',
  trade_reprint: 'Reprint',
  trade_reupload: 'Re-upload',
  trade_refund: 'Refund',
  trade_refunded: 'Refunded',
  trade_upload_fail_tab: 'Upload failed',
  trade_unknown_tab: 'Unknown',
  trade_refund_amount: 'Refund amount',
  trade_refund_amount_ph: 'Enter refund amount ',
  trade_need_refund_amount: 'Enter refund amount',
  trade_need_scan_qr: 'Please scan QR',
  trade_submit_ok: 'Submitted',
  trade_txn_01: 'Sale',
  trade_txn_02: 'Sale void',
  trade_txn_03: 'Refund',
  trade_txn_05: 'Pre-auth',
  trade_txn_07: 'Pre-auth void',
  trade_txn_09: 'Pre-auth complete',
  trade_txn_11: 'Complete void',
  trade_pick_date: 'Select date',
  trade_unclear: 'Unclear',
  trade_ok: 'OK',
  trade_fail_short: 'Fail',
  trade_order_time: 'Order time:',
  trade_sync: 'Sync txn',
  trade_upload_fail_msg: 'Upload failed',
  trade_reupload_ask: 'Re-upload?',
  trade_one_key_upload: 'Upload all',
  trade_resend: 'Resend',
  trade_uploading: 'Uploading',
  trade_method: 'Pay method',
  trade_mch_order: 'Merchant order',
  trade_order_time_label: 'Order time',
  trade_order_amount: 'Order amount',
  trade_real_amount: 'Paid amount',
  trade_mch_remark: 'Merchant remark',
  trade_op_remark: 'Operator remark',
  trade_print_info: 'Print info',
  trade_discount_query: 'Query discount',
  trade_submit_order: 'Submit',
  trade_discount_info: 'Discount info',
  trade_refund_break: 'Refund interrupted',
  trade_abort_ask: 'Abort this order?',
  trade_suspend_ask: 'Suspend order? Resume via repush later.',
  trade_title: 'Trade',
  trade_reprint_title: 'Reprint',
  trade_pay_way: 'Pay method',
  trade_detail: 'Detail',
  trade_acquirer: 'Acquirer',
  trade_paid_amount: 'Paid',
  trade_discount_amount: 'Discount',
  trade_discount_channel: 'Discount channel',
  trade_act_name: 'Campaign',
  trade_refund_status: 'Refund status',
  trade_refund_partial: 'Partial refund',
  trade_refund_full: 'Full refund',
  trade_refund_times: 'Refund times',
  trade_refund_total: 'Refund total',
  trade_void_today: 'Same-day void',
  trade_refund_txn: 'Refund',
  trade_unknown_query: 'Unknown query',
  trade_waiting: 'Waiting',
  trade_fail_status: 'Failed',
  trade_ok_status: 'OK',
  trade_process_ok: 'Processed',
  trade_repush: 'Repush',

  act_title: 'Campaigns',
  act_ongoing: 'Ongoing',
  act_history: 'Upcoming/History',
  act_not_start: 'Not started',
  act_minus: 'Off',
  act_discount: '% off',
  act_cap: 'Cap',
  act_start: 'Start: ',
  act_end: 'End: ',

  discashier_title: 'Discount trade',
  discashier_amount: 'Amount',
  discashier_amount_ph: 'Enter pay amount',
  discashier_amount_error: 'Invalid amount',

  refund_title: 'Refund',
  refund_void_today: 'Same-day void',
  refund_dis: 'Discount refund',
  refund_next_day: 'Next-day refund',
  refund_qr: 'QR refund',
  refund_dis_title: 'Discount refund',
  refund_act_order: 'Campaign order',
  refund_act_order_origin: 'Original campaign order',
  refund_next_day_title: 'Next-day refund',
  refund_qr_order: 'Order No.',
  refund_qr_order_origin: 'Original QR order No.',
  refund_need_ref: 'Enter original reference No.',

  authority_title: 'Trade switches',
  authority_bank_void: 'Allow same-day bank void',
  authority_bank_refund: 'Allow next-day bank refund',
  authority_bank_pre_void: 'Allow pre-auth void',
  authority_bank_pre_confirm_void: 'Allow pre-auth complete void',
  authority_bank_pre_confirm_refund: 'Allow pre-auth complete refund',
  authority_qr_void: 'Allow same-day QR void',
  authority_qr_refund: 'Allow next-day QR refund',

  luck_title: 'Lucky draw',
  luck_act_order: 'Campaign order',
  luck_act_order_ph: 'Original campaign order No.',
  luck_need_act_order: 'Enter campaign order No.',
  luck_discount_info: 'Discount info',
  luck_draw_info: 'Draw info',
  luck_order_status: 'Order status',
  luck_level: 'Prize level',
  luck_prize: 'Prize',
  luck_remark: 'Remark',
  luck_status: 'Status',
  luck_pre_deduct_ok: 'Discount pre-deducted',
  luck_not_won: 'No prize',
  luck_claimed: 'Claimed',
  luck_unclaimed: 'Unclaimed',
  luck_returned: 'Returned',
  luck_registered: 'Registered',
  trade_voided: 'Voided',

  bank_flow_title: 'Bank flow',
  bank_term_seq: 'Terminal seq',
  bank_ref_origin: 'Original reference No.',
  bank_start: 'Start time',
  bank_end: 'End time',
  bank_time_desc: 'Newest first',
  bank_error: 'Error, contact support',

  qr_query_title: 'QR query',
  qr_order_no: 'Order No.',
  qr_order_origin: 'Original QR order No.',
  qr_need_order: 'Enter order No.',
  qr_synced: 'Synced locally',

  quick_cashier_title: 'Quick cashier',
  quick_cashier_no: 'Order:',

  connect_reconnect: 'Reconnect now',
  connect_retry_ss: 'Disconnected, reconnect in {0}',
  connect_fail_ss: 'Connect failed, retry in {0}',
  connect_fail: 'Connect failed',
  connect_ok: 'Connected',

  discount_act_colon: 'Campaign:',
  discount_order_colon: 'Discount order:',
  discount_order_local: 'Local/discount order'
}



// WEBPACK FOOTER //
// ./src/locale/en.js